var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Device, useShowToast } from "@madmedical/ui";
import { useState } from "react";
import { AppleDeviceType } from "@madmedical/medical";
import { useTranslation } from "@madmedical/i18n";
import useAppleContext from "../apple/useAppleContext";
import { useBindDeviceMutation, useUnbindDeviceMutation } from "../api";
const AppleDevice = ({ device, canAddDevice, showAppDownload, onDismissAppDownload, }) => {
    const { connect, disconnect } = useAppleContext();
    const [isLoading, setLoading] = useState(false);
    const [bind] = useBindDeviceMutation();
    const [unbind] = useUnbindDeviceMutation();
    const showToast = useShowToast();
    const { t } = useTranslation();
    const handleConnectPress = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!connect) {
            // Probably not iOS
            return;
        }
        setLoading(true);
        try {
            const connected = yield connect();
            if (!connected) {
                showToast(t("unsuccessfulConnection"), { variant: "error" });
                return;
            }
            yield bind({
                provider: AppleDeviceType.Apple,
                deviceId: "n/a",
            });
            showToast(t("successfulConnection"), { variant: "success" });
        }
        catch (e) {
            console.error(e);
            showToast(t("unsuccessfulConnection"), { variant: "error" });
        }
        finally {
            setLoading(false);
        }
    });
    const handleDisconnectPress = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!disconnect) {
            // Probably not iOS
            return;
        }
        setLoading(true);
        try {
            const disconnected = yield disconnect();
            if (!disconnected) {
                showToast(t("deviceDisconnectedUnsuccessful"), {
                    variant: "error",
                });
                return;
            }
            yield unbind({ provider: AppleDeviceType.Apple });
            showToast(t("deviceDisconnected"), { variant: "success" });
        }
        catch (e) {
            console.error(e);
            showToast(t("deviceDisconnectedUnsuccessful"), {
                variant: "error",
            });
        }
        finally {
            setLoading(false);
        }
    });
    return (_jsx(Device, { device: device, protocols: [], onConnectPress: handleConnectPress, onDisconnectPress: handleDisconnectPress, canAddDevice: canAddDevice, isConnectLoading: isLoading, showAppDownload: showAppDownload, onDismissAppDownload: onDismissAppDownload }));
};
export default AppleDevice;
